import { ReactComponent as ArrowLeftBracket } from '@assets/icons/arrow_left_bracket.svg';
import { ReactComponent as ArrowRightBracket } from '@assets/icons/arrow_right_bracket.svg';
import { ReactComponent as FocusedArrowLeftBracket } from '@assets/icons/focused_arrow_left_bracket.svg';
import { ReactComponent as FocusedArrowRightBracket } from '@assets/icons/focused_arrow_right_bracket.svg';
import { KeyPressDetails, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { FC } from 'react';

import * as S from './styles';

interface FocusableButtonProps {
  isLeft: boolean;
  onEnterPress: (props: object, details: KeyPressDetails) => void;
}

const HorizontalScrollArrow: FC<FocusableButtonProps> = (props) => {
  const { isLeft, onEnterPress } = props;

  const { ref, focused } = useFocusable({
    onEnterPress
  });

  return (
    <div ref={ref}>
      {isLeft ? (
        focused ? (
          <FocusedArrowLeftBracket css={S.icon} />
        ) : (
          <ArrowLeftBracket css={S.icon} />
        )
      ) : focused ? (
        <FocusedArrowRightBracket css={S.icon} />
      ) : (
        <ArrowRightBracket css={S.icon} />
      )}
    </div>
  );
};

export default HorizontalScrollArrow;
